export const categories = [
  { value: 'Assaggiatore', label: 'Assaggiatore' },
  { value: 'Sommelier', label: 'Sommelier' },
  { value: 'Online', label: 'Online' },
  { value: 'Master', label: 'Master' },
  { value: 'Approfondimento', label: 'Approfondimento' },
];
